"use client";

import { useTheme } from "next-themes";
import { Toaster as Sonner } from "sonner";
import type { ToasterProps } from "sonner";

const Toaster = ({ ...props }: ToasterProps) => {
  const { theme = "system" } = useTheme();

  return (
    <Sonner
      theme={theme as ToasterProps["theme"]}
      className="toaster group"
      offset={{
        // workaround until https://github.com/emilkowalski/sonner/issues/361 is fixed
        top: 72,
        right: 32,
      }}
      style={
        {
          "--normal-bg": "var(--secondary)",
          "--normal-text": "var(--secondary-foreground)",
          "--normal-border": "var(--border)",
        } as React.CSSProperties
      }
      {...props}
    />
  );
};

export { Toaster };
